<template>
  <div class="aircraft-main-container">
    <div class="common-section-container gap-xl">
      <div class="common-section-content">
        <div class="header-text-info mb-3">Documents - ARROWPEC</div>
        <div class="common-section-flex gap-sm1" v-for="(document, index) in documents" :key="index">
          <input type="checkbox" :id="document.model" v-model="form[document.model]">
          <label :for="document.model">{{ document.label }}</label>
        </div>
      </div>
      <div class="common-section-content gap-sm1">
        <div class="grid gap-sm" :style="$global.dynamicColsV2(1.5, 1, 1)">
          <div class="header-text-info mb-3">Inspections</div>
          <div class="header-text-info mb-3 text-center">Most Recent</div>
          <div class="header-text-info mb-3 text-center">Next</div>
        </div>
        <div class="d-flex flex-column gap-sm1">
          <div class="grid gap-sm" v-for="(inspection, index) in inspections" :key="index" :style="$global.dynamicColsV2(1.5, 1, 1)">
            <div>{{ inspection.label }}</div>
            <input type="text" v-model="form[inspection.model]" disabled class="text-center">
            <div @click="toggleDatePicker(inspection.model)" style="cursor: pointer;">
              <input
                type="text"
                placeholder="Choose date..."
                v-model="form[`${inspection.model}nextDate`]"
                disabled
                style="pointer-events: none;"
              >
            </div>
          </div>
        </div>
      </div>
    </div>

    <DateTimePicker
      :isVisible="showDatePicker"
      @close="toggleDatePicker"
      @getDate="getDate"
    />

    <div>
      <button class="primary" @click="$emit('next')">Next</button>
    </div>
  </div>
</template>

<script>
import DateTimePicker from './DateTimePicker.vue';
export default {
  components: { DateTimePicker },
  data() {
    return {
      form: {},
      documents: [
        { model: 'airworthinessCert', label: 'Airworthiness Certificate' },
        { model: 'registrationCert', label: 'Registration Certificate' },
        { model: 'radioStationLicense', label: 'Radio Station License - Flying Outside US' },
        { model: 'operatingHandbook', label: 'Operating Handbook' },
        { model: 'placards', label: 'Placards' },
        { model: 'externalDataPlate', label: 'External Data Plate' },
        { model: 'compassDeviationCars', label: 'Compass Deviation Cars' },
      ],
      inspections: [
        { label: 'Annual - 12 Calendar Months', mostRecent: '03/26/2025', model: 'annual' },
        { label: 'VOR - 30 Days (IFR)', mostRecent: '03/26/2025', model: 'vor' },
        { label: '100 Hour - Every 100 Hours', mostRecent: '03/26/2025', model: 'every100Hours' },
        { label: 'Altimeter - 24 Cal Months (IFR)', mostRecent: '03/26/2025', model: 'altimeter' },
        { label: 'Transponder - 24 Cal Months', mostRecent: '03/26/2025', model: 'transporter' },
        { label: 'ELT Inspection - 12 Cal Months', mostRecent: '03/26/2025', model: 'eltInspection' }
      ],
      showDatePicker: false,
      selectedModel: null
    };
  },
  mounted() {
    this.inspections.forEach(inspection => {
      this.$set(this.form, inspection.model, inspection.mostRecent)
    });
  },
  watch: {
    showDatePicker(newVal) {
      if(!newVal) {
        this.showDatePicker = null;
        this.$forceUpdate();
      }
    }
  },
  methods: {
    toggleDatePicker(model) {
      this.selectedModel = model;
      this.showDatePicker = !this.showDatePicker;
    },
    getDate(val) {
      this.form[`${this.selectedModel}nextDate`] = val;
    },
  },
};
</script>

<style>
.aircraft-main-container {
  max-width: 600px;
}
.common-section-container input[type="checkbox"] {
  width: fit-content;
  margin-top: 4px;
}
.common-section-container label {
  color: #404040 !important;
}
.common-section-flex {
  display: flex;
}
</style>
